"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const asTree = require("./asTree.cjs");
const serialize = (richTextField, serializer) => {
  return serializeTreeNodes(asTree.asTree(richTextField).children, serializer);
};
const serializeTreeNodes = (nodes, serializer) => {
  const serializedTreeNodes = [];
  for (let i = 0; i < nodes.length; i++) {
    const treeNode = nodes[i];
    const serializedTreeNode = serializer(treeNode.type, treeNode.node, treeNode.text, serializeTreeNodes(treeNode.children, serializer), treeNode.key);
    if (serializedTreeNode != null) {
      serializedTreeNodes.push(serializedTreeNode);
    }
  }
  return serializedTreeNodes;
};
exports.serialize = serialize;
//# sourceMappingURL=serialize.cjs.map
